module.exports = __webpack_public_path__ + "static/media/forward-no-fill.78d021e2.svg";